import React, {useCallback,useContext,useEffect,useRef,useState} from "react";
import { AuthContext } from "../../../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../../../config/api";

const Grupo2 = ({ datos, handleChange, eliminarFila }) => {

    const { authFetch } = useContext(AuthContext);

    const [departments, setDepartments] = useState([]);
    const [municipalitiesByRow, setMunicipalitiesByRow] = useState({});

    const municipiosCargados = useRef({});

    // Cargar departamentos
    useEffect(() => {

        const fetchDepartments = async () => {

            try {

                const res = await authFetch(ENDPOINTS.getDepartment);

                setDepartments(res.data || []);

            } catch (error) {

                console.error("Error cargando departamentos:", error);

            }

        };

        fetchDepartments();

    }, [authFetch]);

    // Cargar municipios
    const cargarMunicipios = useCallback(
        async (index, departamentoNombre) => {

            if (!departamentoNombre) {

                setMunicipalitiesByRow(prev => ({
                    ...prev,
                    [index]: []
                }));

                return;
            }

            const departamento = departments.find(
                dep => dep.nombre === departamentoNombre
            );

            if (!departamento) {

                setMunicipalitiesByRow(prev => ({
                    ...prev,
                    [index]: []
                }));

                return;
            }

            const key = `${index}-${departamento.id_departamento}`;

            // Evitar volver a consultar el mismo departamento
            // para la misma fila
            if (municipiosCargados.current[key]) {
                return;
            }

            municipiosCargados.current[key] = true;

            try {

                const res = await authFetch(
                    ENDPOINTS.getMunicipios(
                        departamento.id_departamento
                    )
                );

                setMunicipalitiesByRow(prev => ({
                    ...prev,
                    [index]: res.data || []
                }));

            } catch (error) {

                console.error(
                    "Error cargando municipios:",
                    error
                );

                setMunicipalitiesByRow(prev => ({
                    ...prev,
                    [index]: []
                }));

            }

        },
        [departments, authFetch]
    );

    // mostrar
    useEffect(() => {

        if (departments.length === 0 || datos.length === 0) {
            return;
        }

        datos.forEach((item, index) => {

            if (item.departamento) {

                cargarMunicipios(
                    index,
                    item.departamento
                );

            }

        });

    }, [departments, datos, cargarMunicipios]);

    // Cambiar el departamento
    const handleDepartamentoChange = async (index, departamentoNombre) => {

        // Guardamos el NOMBRE del departamento
        handleChange(
            index,
            "departamento",
            departamentoNombre
        );

        // Cuando cambia departamento,
        // el municipio anterior deja de ser válido
        handleChange(
            index,
            "municipio",
            ""
        );

        // Limpiamos municipios anteriores de esa fila
        setMunicipalitiesByRow(prev => ({
            ...prev,
            [index]: []
        }));

        // Buscar y cargar los municipios del nuevo departamento
        if (departamentoNombre) {

            await cargarMunicipios(
                index,
                departamentoNombre
            );

        }

    };

    return (

        <div>

            {/* TABLA */}

            <div className="table-responsive">

                <table className="table align-middle">

                    <thead className="table-secondary">

                        <tr>

                            <th>Departamento</th>
                            <th>Municipio</th>
                            <th>Unidades Territoriales</th>
                            <th style={{ minWidth: "300px" }}>Descripción de la iniciativa</th>
                            <th style={{ width: "140px" }}>Avance Mes</th>
                            <th style={{ width: "150px" }}>Subcontratado</th>
                            <th style={{ width: "80px" }}>Acción</th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            datos.length === 0 &&

                            <tr>
                                <td colSpan={7} className="text-center">No hay registros. Presione "Agregar fila" para comenzar.</td>
                            </tr>

                        }

                        {

                            datos.map((item, index) => (

                                <tr key={index}>

                                    <td>

                                   <select
                                        className="form-select"
                                        value={item.departamento || ""}
                                        onChange={(e) =>
                                            handleDepartamentoChange(
                                                index,
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="">
                                            Seleccione departamento
                                        </option>

                                        {departments.map((dep) => (
                                            <option
                                                key={dep.id_departamento}
                                                value={dep.nombre}
                                            >
                                                {dep.nombre}
                                            </option>
                                        ))}
                                    </select>

                                    </td>

                                    <td>

                                        <select
                                                className="form-select"
                                                value={item.municipio || ""}
                                                disabled={!item.departamento}
                                                onChange={(e) =>
                                                    handleChange(
                                                        index,
                                                        "municipio",
                                                        e.target.value
                                                    )
                                                }
                                            >
                                                <option value="">
                                                    Seleccione municipio
                                                </option>

                                                {(municipalitiesByRow[index] || []).map((mun) => (
                                                    <option
                                                        key={mun.id_municipio}
                                                        value={mun.nombre}
                                                    >
                                                        {mun.nombre}
                                                    </option>
                                                ))}
                                            </select>

                                    </td>

                                    <td>

                                        <input
                                            className="form-control"
                                            placeholder="Unidad Territorial"
                                            value={item.unidades_territoriales || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "unidades_territoriales",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <textarea
                                            className="form-control"
                                            rows={3}
                                            placeholder="Descripción..."
                                            value={item.descripcion_iniciativa || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "descripcion_iniciativa",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>
                                      <div className="input-group">

                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            max="100"
                                            step="1"
                                            value={item.avance_mes ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "avance_mes",
                                                    e.target.value
                                                )
                                            }
                                        />

                                        <span className="input-group-text">%</span>

                                    </div>

                                    </td>

                                   <td>

                                        <input
                                            className="form-control"
                                            placeholder="Subcontratado"
                                            value={item.subcontratado || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "subcontratado",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td className="text-center">

                                        <button className="btn btn-sm btn-danger" onClick={() =>eliminarFila(index)}>

                                            <i className="bi bi-trash"></i>

                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default Grupo2;